
















import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';

import CTABladeContainer from './ui/CTABladeContainer.vue';
import CTABladeButton from './ui/CTABladeButton.vue';
import CTABladeBody from './ui/CTABladeBody.vue';
import CTABladeTitle from './ui/CTABladeTitle.vue';
import CTABladeHeadline from './ui/CTABladeHeadline.vue';
import { IVariant, COLOR_OPTIONS } from './index';

const variantSelected = (color: string) => {
  let colorOption = '';
  const colorOptionsObject: String[] = Object.values(COLOR_OPTIONS);

  if (colorOptionsObject.includes(color.toLowerCase())) {
    colorOption = color.toUpperCase();
  } else {
    colorOption = 'DARK';
  }

  return colorOption;
};

const variants = {
  DARK: {
    backgroundColor: 'bg-brandPrimary',
    headlineColor: 'text-grayBackground',
    bodyColor: 'text-grayLine',
  },

  WHITE: {
    backgroundColor: 'bg-white',
    headlineColor: 'text-baseTertiary',
    bodyColor: 'text-grayBody',
  },

  GREY: {
    backgroundColor: 'bg-grayBackgroundWeak',
    headlineColor: 'text-grayHeader',
    bodyColor: 'text-grayBody',
  },
  NEUTRAL: {
    backgroundColor: 'bg-baseSecondary',
    headlineColor: 'text-grayHeader',
    bodyColor: 'text-grayBody',
  },
  LIGHTPURPLE: {
    backgroundColor: 'bg-basePrimary',
    headlineColor: 'text-grayBackground',
    bodyColor: 'text-grayLine',
  },
  PURPLEGRADIENT: {
    backgroundImage: '',
    headlineColor: 'text-grayBackground',
    bodyColor: 'text-grayBackground',
  },
} as IVariant;

export default defineComponent({
  name: 'CTABlade',
  components: {
    CTABladeContainer,
    CTABladeButton,
    CTABladeBody,
    CTABladeTitle,
    CTABladeHeadline,
  },

  props: {
    title: {
      type: String as PropType<string>,
      default: 'Want to learn more about Bambee?',
    },
    headline: {
      type: String as PropType<string>,
      default: 'Want to learn more about Bambee?',
    },
    body: {
      type: String as PropType<string>,
      default:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    buttonText: {
      type: String as PropType<string>,
      default: 'Want to learn more about Bambee?',
    },
    buttonLink: {
      type: String as PropType<string>,
      default: '',
    },
    variant: {
      type: String as PropType<string>,
      default: COLOR_OPTIONS.DARK,
    },
    showButton: {
      type: String,
      default: 'true',
    },
  },

  setup(props) {
    const colorOption = variantSelected(props.variant);
    const isButton = computed(() => props.showButton === 'true');

    return {
      colorOption,
      variants,
      isButton,
    };
  },
});
